<template>
  <tr v-if="!isMob" :class="{_full: full}" class="_reg">
    <td class="_user">
      <div class="account-tab-item__user-wrap">
        <div class="account-tab-item__photo">
          <picture class="account-tab-item__photo-wrap">
            <img src="https://thispersondoesnotexist.com/image" alt="photo">
          </picture>
          <!--          <div class="account-tab-item__photo-caption">-->
          <!--            <span>+4</span>&nbsp;-->
          <!--            <BaseSvg name="ico-photo-2"/>-->
          <!--          </div>-->
        </div>
        <div class="account-tab-item__user">
          <div class="account-tab-item__user-name">Lorem ipsum dolor sit amet</div>
          <div class="account-tab-item__user-age">(24 {{$tGlobal('years', 24)}})</div>
        </div>
      </div>
    </td>

    <td class="_vacancy">
      <a href="#"
         class="account-tab-item__btn base-btn base-btn--outline-grey--green base-btn--small">
        <span>Требуются строители или строительные бригады</span>
      </a>
    </td>

    <td class="_date">
      <div class="account-tab-item__date">23.01.2020</div>
    </td>

    <td class="_stage">
      <div class="account-tab-item__stage">
        <BaseSvg name="ico-umbrella"/>
        <span>Покупка страховки</span>
      </div>
      <div v-if="full" class="account-tab-item__interaction">
        <a href="#" class="account-tab-item__interaction-link inline-link">
          <span>{{$tResumeList('Go to interaction page')}}</span>&nbsp;
          <BaseSvg name="ico-arrow-light" class="_arrow"/>
        </a>
      </div>
    </td>

    <td class="_interaction" v-if="!full">
      <div class="account-tab-item__interaction">
        <a href="#" class="account-tab-item__interaction-link inline-link">
          <span>{{$tResumeList('Go to interaction page')}}</span>&nbsp;
          <BaseSvg name="ico-arrow-light" class="_arrow"/>
        </a>
      </div>
    </td>

    <td v-if="full" class="_lead">
      <div class="account-tab-item__user-small">
        <span class="account-tab-item__user-small-avatar" style="background-color: #b3a3c1;">AM</span>
        <span class="account-tab-item__user-small-name">Артур Мартиросян</span>
      </div>
    </td>
  </tr>
  <div  v-else class="account-tab-item__group-item" :class="{_full: full}">
    <div class="account-tab-item__group-item-top">
      <div class="account-tab-item__photo">
        <picture class="account-tab-item__photo-wrap">
          <img src="https://thispersondoesnotexist.com/image" alt="photo">
        </picture>
<!--        <div class="account-tab-item__photo-caption">-->
<!--          <span>+4</span>&nbsp;-->
<!--          <BaseSvg name="ico-photo-2"/>-->
<!--        </div>-->
      </div>
      <div class="account-tab-item__group-item-top-col">
        <div class="account-tab-item__user">
          <div class="account-tab-item__user-name">Lorem ipsum dolor sit amet</div>
          <div class="account-tab-item__user-age">(24 {{$tGlobal('years', 24)}})</div>
        </div>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div class="account-tab-item__vacancy-mob">
        <div class="account-tab-item__label-mob">{{$tResumeList('Vacancy')}}</div>
        <a href="#"
           class="account-tab-item__btn base-btn base-btn--outline-grey--green base-btn--small">
          <span>Требуются строители или строительные бригады</span>
        </a>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div class="account-tab-item__lead-mob" v-if="full">
        <span class="account-tab-item__label-mob">{{$tResumeList('Lead')}}</span>
        <span class="account-tab-item__lead-avatar" style="background-color: #b3a3c1;">AM</span>
      </div>
      <div class="account-tab-item__stage-mob">
        <span class="account-tab-item__label-mob" v-if="full">{{$tResumeList('Stage')}}</span>
        <span class="account-tab-item__label-mob" v-else>{{$tResumeList('Stage of registration')}}</span>
        <div class="account-tab-item__stage">
          <BaseSvg name="ico-umbrella"/>
        </div>
      </div>
      <div class="account-tab-item__date"><BaseSvg name="ico-chevron"/>23.01.2020</div>
    </div>

    <div class="account-tab-item__group-item-row">
      <a href="#" class="account-tab-item__interaction-link inline-link">
        <span>{{$tResumeList('Go to interaction page')}}</span>&nbsp;
        <BaseSvg name="ico-arrow-light" class="_arrow"/>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResumeTabItemRegRow',
    props: {
      full: {
        type: Boolean,
        default: false
      },
      isMob: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>

</style>
